module.exports = __webpack_public_path__ + "static/media/en.4f1b7af5.svg";